<template>
  <base-detail :title="'Mutton Starters'">
    <ul>
      <li class="menuList" v-for="item in muttonStarters" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
    </ul>
  </base-detail>
</template>

<script>
import data from "./../../../data.json";
export default {
  computed: {
    muttonStarters() {
      const dataList = data.filter(
        (row) => row.type === "mutton" && row.mealType === "starters"
      );
      return dataList;
    },
  },
};
</script>
